<template>
  <div 
    v-if="storageStore.queueUIVisible"
    class="queue-progress-panel"
    :class="{ 'expanded': storageStore.queueUIExpanded }"
  >
    <QueueProgressHeader />
    <QueueTaskList v-if="storageStore.queueUIExpanded" />
    <QueueProgressFooter v-if="storageStore.queueUIExpanded" />
  </div>
</template>

<script setup>
import { useStorageStore } from '@/stores/storageStore'
import QueueProgressHeader from './QueueProgressHeader.vue'
import QueueTaskList from './QueueTaskList.vue'
import QueueProgressFooter from './QueueProgressFooter.vue'

const storageStore = useStorageStore()
</script>

<style scoped>
.queue-progress-panel {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 320px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  transition: all 0.3s ease;
  transform: translateX(100%);
  animation: slideIn 0.3s ease forwards;
}

.queue-progress-panel:not(.expanded) {
  width: 280px;
}

@keyframes slideIn {
  to {
    transform: translateX(0);
  }
}

/* モバイル対応 */
@media (max-width: 768px) {
  .queue-progress-panel {
    bottom: 10px;
    right: 10px;
    left: 10px;
    width: auto;
  }
  
  .queue-progress-panel:not(.expanded) {
    width: auto;
  }
}
</style>